import { configure } from "@cervval.js/client-html5-spa";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { buildDefaultErrorMessageService } from "@cervval.js/common/src/services/errorMessage.impl/default.errorMessage.service";
import { GLOBAL_LOCALE_SERVICE, GlobalLocaleService } from "@neoplan/common-shared/src/services/globalLocale.service";
import { LoginClientMainService } from "../services/loginClientMainService.service";
import { setupApplicationLookAndFeel } from "./lookAndFeel";
import { getNavigationServiceConfiguration } from "./navigation";


setupApplicationLookAndFeel(); // load bootstrap and app style
registerServices();
const localeService = injector.get<GlobalLocaleService>(GLOBAL_LOCALE_SERVICE);
const locale = localeService.getLocale() as "_en" | "_fr";

const metaTitle = document.querySelectorAll("[ref=tabTitle]");

const i18n = {
    _en: { label: "Login to NEOPLAN" },
    _fr: { label: "Connexion à NEOPLAN" }
};
const title = i18n[locale].label;
metaTitle.forEach((element) => element.innerHTML = `${title}`);

// Configure the single page application
configure({
    configureNavigation: getNavigationServiceConfiguration()
});

/**
 * Register services
 */
function registerServices(): void {
    injector.register(new GlobalLocaleService());
    injector.register(new LoginClientMainService());
    injector.register(buildDefaultErrorMessageService());
}